export default function getShiftById(id = null, shifts) {
  if (id === null) return {}
  return shifts.find(shift => shift.id === id)
}
